/*
 * @Author: Shirtiny
 * @Date: 2021-06-08 17:06:56
 * @LastEditTime: 2021-06-09 15:24:23
 * @Description:
 */
import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import theme from "./theme";
import "normalize.css";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "pikaday/css/pikaday.css";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import data from "services/data";
import http from "utils/http";
import fakeData from "utils/fakeData";
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

ReactDOM.render(
  <React.Fragment>
    <HashRouter>
      <ThemeProvider theme={theme}>
      <ConfigProvider locale={zhCN}>
        <App />
      </ConfigProvider>
      </ThemeProvider>
    </HashRouter>
  </React.Fragment>,
  document.getElementById("root")
);

// 添加假插件数据
// setTimeout(() => {
//   fakeData.addFakePlugins();
// }, 10000);

// "proxy": "http://192.168.88.25:9999"

// data.searchPluginInfoList(100, 1, "plugins/nginx");

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
